import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from 'core-tsi';

const CIA_TSI = 25;

export const hasAccessCiaGuard = (cia:number = CIA_TSI) : CanActivateFn => {
  return () => {
    const router = inject(Router)
    const sesion = StorageService.getSession()
    const id_cia = sesion?.id_cia;
    const hasAccess = id_cia == cia
    return hasAccess ? true : router.createUrlTree(['/unauthorized']);
  };
};
